"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactHelmet = require("react-helmet");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var version = _ref.version,
      date = _ref.date,
      env = _ref.env;
  return /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("meta", {
    name: "version",
    content: version
  }), /*#__PURE__*/_react["default"].createElement("meta", {
    name: "date",
    content: date
  }), /*#__PURE__*/_react["default"].createElement("meta", {
    name: "environment",
    content: env
  }), /*#__PURE__*/_react["default"].createElement("meta", {
    name: "sanity",
    content: 'active'
  }));
};

exports["default"] = _default;